<div *ngIf="fullPage" [hidden]="!loading" id="candLoaderWrapper">
    <section class="simulation simulation__group cand-webapp-loader">
        <h1 class="page-title">{{ title }}</h1>
        <div class="simulation__content cand-webapp-loader__content">
            <span class="loader"></span>
            <p>Nous sommes en train de charger la page <span class="cand-webapp-loader__titleDots">...</span></p>
        </div>
    </section>
</div>
<div *ngIf="!fullPage" class="simulation__paragraph grid-12 grid-mobile-4 no-gutter ng-scope" [hidden]="!loading" style="">
    <p class="loading-page--icon"><span class="loader loader--spinner"></span></p>
    <p class="loading-page--text ng-binding">{{ text | i18n }}</p>
</div>
